
import Axios from '../config/axios';

export const fetcher = url => Axios.get(url).then(res => res.data);